import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';

import NoCurrentChats from "./NoCurrentChats";
import ChatDetail from "./ChatDetail";



@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})

class ChatCenter extends Component {

    constructor(props) {
        super(props);


    }



    render() {
        const { t } = this.props;





            if(typeof this.props.chatprop.activeChats.filter(cC=>cC.id==this.props.id)[0]!=="undefined") {
                return (
                    <>
                       <ChatDetail type="active" closeSupervised={this.props.closeSupervised} closeChat={this.props.closeChat} userBan={this.props.userBan} chat={this.props.chatprop.activeChats.filter(cC=>cC.id==this.props.id)[0]} id={this.props.id}/>
                    </>
                )
            } else{
                return (
                    <NoCurrentChats description="Please select a chat to start messaging."/>
                )
            }


    }
}

export default withTranslation()(ChatCenter);
